import Button from "../../../components/Button";
import ProgressBar from "../../../components/ProgressBar";
import AddIcon from "/public/images/icons/add.svg?react";
import { useNavigate } from "react-router-dom";
import { useDrawerContext } from "../../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import TextInput from "../../../components/TextInput";
import { useState } from "react";
import MedicalCard from "../../../components/MedicalCard";
import PropTypes from "prop-types";

export default function GuestBandStep4({ band }) {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const [medication, setMedication] = useState(
    JSON.parse(localStorage.getItem("activeGuestBandStep4")) || []
  );

  const openMedicalDrawer = (index) => {
    // Provide a unique key based on index to force re-render
    setOpen(true);
    setDrawerContent(
      <div className="w-full" key={`drawer-${index}`}>
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
          MEDICATION
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col justify-stretch">
          <h3 className="text-[24px]">
            {index < medication.length ? "Edit your medication" : "Enter your medication name"}
          </h3>
          <form
            onSubmit={(e) => index < medication.length ? editMedication(e, index) : addMedication(e)}
            className="flex flex-col gap-6"
          >
            <TextInput
              defaultValue={index < medication.length ? medication[index]?.medicationName || "" : ""}
              label={"Medication Name"}
              name={`medicationName${index}`}
              required={true}
            />
            <TextInput
              defaultValue={index < medication.length ? medication[index]?.medicationDosage || "" : ""}
              label="Dosage"
              name={`dosage${index}`}
              required={true}
            />
            <TextInput
              defaultValue={index < medication.length ? medication[index]?.medicationFrequency || "" : ""}
              label="Frequency"
              name={`frequency${index}`}
              required={true}
            />
            <TextInput
              defaultValue={index < medication.length ? medication[index]?.additionalInformation || "" : ""}
              name={`additionalInformation${index}`}
              label="Additional Information"
            />
            <Button submit>
              Confirm & Continue
            </Button>
          </form>
        </div>
      </div>
    );
  };

  const addMedication = (event) => {
    event.preventDefault();
    const newDetails = new FormData(event.currentTarget);

    setMedication((prevMedication) => [
      ...prevMedication,
      {
        medicationName: newDetails.get(`medicationName${medication.length}`),
        medicationDosage: newDetails.get(`dosage${medication.length}`),
        medicationFrequency: newDetails.get(`frequency${medication.length}`),
        additionalInformation: newDetails.get(`additionalInformation${medication.length}`),
        dateAdded: new Date(),
        ongoing: false,
      },
    ]);
    setOpen(false);
    setDrawerContent(<div></div>);
  };

  const editMedication = (event, index) => {
    event.preventDefault();
    const newDetails = new FormData(event.currentTarget);

    setMedication((prevMedication) =>
      prevMedication.map((item, i) =>
        i === index
          ? {
              ...item,
              name: newDetails.get(`medicationName${index}`),
              dosage: newDetails.get(`dosage${index}`),
              frequency: newDetails.get(`frequency${index}`),
              additionalInformation: newDetails.get(`additionalInformation${index}`),
            }
          : item
      )
    );
    setOpen(false);
  };

  const removeMedication = (index) => {
    setMedication((prevMedication) => prevMedication.filter((_, i) => i !== index));
  };

  const checkOngoing = (index) => {
    setMedication((prevMedication) =>
      prevMedication.map((item, i) =>
        i === index
          ? {
              ...item,
              ongoing: !item.ongoing,
            }
          : item
      )
    );
  };

  const validateStep5 = () => {
    localStorage.setItem("activeGuestBandStep4", JSON.stringify(medication));
    navigate(`/guest-bands/${band?.BandID}/activate/complete`, { state: { band } });
  };

  return (
    <div className="w-full min-h-svh flex flex-col justify-stretch mb-[50px] bg-[#F8F8F8]">
      <div className="p-[24px] flex flex-col gap-6 bg-white">
        <ProgressBar step={4} overrideTotalSteps={4} />
        <span className="tracking-[0.25em] text-[12px] uppercase font-semibold">
          Step 4
        </span>
        <h2>Please let us know if you take medication</h2>
        <p>
          This information will be visible to venue staff and the public when your band is unlocked.
        </p>
      </div>
  
      {/* Medication Section - Always Rendered */}
      <div className={`bg-sportsLightGrey border-[#E3E3E3] border-t-[1px] p-[24px] flex justify-center flex-col gap-6 ${medication.length <= 1 ? 'pb-[250px]' : 'pb-[200px]'}`}>
        {medication.length > 0 ? (
          medication.map((item, index) => (
            <MedicalCard
              editFunc={() => openMedicalDrawer(index)}
              checkedFunc={() => checkOngoing(index)}
              removeFunc={() => removeMedication(index)}
              key={index}
              medication={item}
              type="medication"
            />
          ))
        ) : (
          <p className="text-[#909090] text-center">No medications have been added</p>
        )}
      </div>
  
      {/* Fixed Buttons at Bottom */}
      <div className="fixed bottom-[60px] left-1/2 transform -translate-x-1/2 w-full max-w-[430px] border-t border-l border-r rounded-t-[32px] border-[#E3E3E3] bg-white p-[24px] flex flex-col justify-stretch gap-4">
        <Button onClick={() => openMedicalDrawer(medication.length)} variant="tertiary">
          <AddIcon className="w-[15px]" />
          {medication.length > 0 ? "Add Another" : "Add Medication"}
        </Button>
        <Button onClick={validateStep5}>
          {medication.length > 0 ? "Confirm & Continue" : "Continue Without Medication"}
        </Button>
      </div>
    </div>
  );
}